import React from 'react';

import SwiperCore, { Navigation, Pagination, EffectFade, A11y, Scrollbar, Virtual, Autoplay, EffectCube, EffectCoverflow } from 'swiper';

import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/swiper.scss';
import 'swiper/components/navigation/navigation.scss';
import 'swiper/components/pagination/pagination.scss';
import 'swiper/components/scrollbar/scrollbar.scss';
import 'swiper/components/effect-coverflow/effect-coverflow.scss';

import './styles.scss'

SwiperCore.use([Navigation, Pagination, Virtual, A11y, Autoplay, EffectFade, EffectCube, EffectCoverflow, Scrollbar]);

const GreetingCard = ({ senderName, occasion, cardName }) => {
    return (
        <div className="card wall-card">
            <header className="card-header">
                <p className="card-header-title">
                    {senderName}
                </p>
            </header>
            <div className="card-image">
                <figure className="image is-4by3">
                    <img src={require(`../../images/${occasion}/${cardName}`)} alt={cardName} />
                </figure>
            </div>
        </div>
    )
}

const WallCards = ({ cards, occasion }) => {
    return (
        <Swiper
            autoplay
            effect={'coverflow'}
            grabCursor
            //spaceBetween={4}
            slidesPerView={'auto'}
            centeredSlides
            freeMode={false}
            autoHeight
            //fadeEffect={true}
            coverflowEffect={{
                rotate: 50,
                stretch: 0,
                depth: 100,
                modifier: 1,
                slideShadows: false,
            }}
            //autoplay
            pagination={{
                clickable: true,
                dynamicBullets: true
                // type: 'fraction',
                // renderBullet: function (index, className) {
                //     return '<span class="' + className + '">' + (index + 1) + '</span>';
                //   },
            }}
            breakpoints={{
                640: {
                    slidesPerView: 1,
                    spaceBetween: 20,
                },
                768: {
                    slidesPerView: 1,
                    spaceBetween: 2,
                },
                1024: {
                    slidesPerView: 4,
                    spaceBetween: 8,
                }
            }}
        >

            {cards.map((item, i) => {
                return (
                    <SwiperSlide key={i}>
                        <GreetingCard senderName={item.senderName} occasion={occasion} cardName={item.cardName} />
                    </SwiperSlide>
                )
            })}


        </Swiper>
    )
};

export default WallCards;